// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal--qaBrY","flex":"flex--NWA8t","title":"title--VOL_N","unit":"unit--BFuIt"};